import { render, staticRenderFns } from "./CreateGamePage.vue?vue&type=template&id=4b98348a&scoped=true&"
import script from "./CreateGamePage.vue?vue&type=script&lang=js&"
export * from "./CreateGamePage.vue?vue&type=script&lang=js&"
import style0 from "./auth.css?vue&type=style&index=0&lang=css&"
import style1 from "./CreateGamePage.vue?vue&type=style&index=1&id=4b98348a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98348a",
  null
  
)

export default component.exports